// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"715a2016","496":"6c180963","747":"c073dbc7","996":"88a8a557"}[chunkId] + ".chunk.js";
};